module.exports = __webpack_public_path__ + "static/img/101682.ad660cd0.png";